import { gql } from '@/__generated__';
import { useQuery } from '@apollo/client';
import { ActionIcon, Group, Paper, Stack, TagsInput, Text } from '@mantine/core';
import { useLocalStorage } from '@mantine/hooks';
import { IconPrinter, IconRefresh } from '@tabler/icons-react';
import { DataTable } from 'mantine-datatable';
import { useState } from 'react';

const liveUnpackedLinesDocument = gql(/* GraphQL */ `
  query LiveUnpackedLinesDocument($live: LiveWhereInput!, $skip: Int, $take: Int) {
    liveUnpackedLines(live: $live, skip: $skip, take: $take) {
      total
      lines {
        id
        code
        name
        description
        price
        productVariant {
          id
          attributes {
            id
            name
            value
          }
        }
        order {
          id
          package
          customer {
            id
            name
          }
        }
      }
    }
  }
`);

export const LiveLinesTable = ({ liveId }: { liveId: string }) => {
  const [employees, setEmployees] = useLocalStorage<string[]>({
    key: 'employees',
    defaultValue: ['Denis', 'David', 'Adrian', 'Sida', 'Lenka', 'Dada', 'Peto B.'],
  });

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);

  const { data, loading, refetch } = useQuery(liveUnpackedLinesDocument, {
    variables: {
      live: { id: { equals: liveId } },
      skip: pageSize * page - pageSize,
      take: pageSize,
    },
    pollInterval: 10 * 1000,
  });

  const records = data?.liveUnpackedLines.lines.map((line) => ({
    id: line.id,
    package: line.order.package,
    customer: line.order.customer.name,
    code: line.code,
    name: line.name,
    description: line.description,
    price: line.price,
    attributes: line.productVariant?.attributes?.map((attr) => attr.value).join(', '),
  }));

  return (
    <Paper p="md" withBorder component={Stack}>
      <Group justify="space-between">
        <Text>Produkty na zabalenie</Text>
        <Group>
          <ActionIcon
            variant="filled"
            onClick={() => {
              void refetch();
            }}
            loading={loading}
          >
            <IconRefresh size={16} />
          </ActionIcon>
          <ActionIcon
            variant="filled"
            color="teal"
            component="a"
            href={`https://api.laskykrasky.sk/api/live/lines?liveId=${liveId}&employees=${employees.join(',')}`}
            target="_blank"
          >
            <IconPrinter size={16} />
          </ActionIcon>
        </Group>
      </Group>
      <TagsInput value={employees} onChange={setEmployees} />
      <DataTable
        withTableBorder
        striped
        highlightOnHover
        borderRadius="sm"
        height={500}
        fetching={loading}
        totalRecords={data?.liveUnpackedLines.total}
        recordsPerPage={pageSize}
        page={page}
        onPageChange={setPage}
        recordsPerPageOptions={[5, 10, 25, 50, 100]}
        onRecordsPerPageChange={setPageSize}
        records={records ?? []}
        columns={[
          { accessor: 'package', title: 'Balík' },
          { accessor: 'customer', title: 'Zákazník' },
          { accessor: 'code', title: 'Kód' },
          { accessor: 'name', title: 'Názov' },
          { accessor: 'description', title: 'Popis' },
          { accessor: 'price', title: 'Cena' },
          { accessor: 'attributes', title: 'Variant' },
        ]}
      />
    </Paper>
  );
};
